import * as R from 'ramda';
import { useDispatch } from 'react-redux';
import React, { useState, useCallback } from 'react';
// components
import { closeModal } from '../components/modal/actions';
import { openLoader, closeLoader } from '../components/loader/actions';
// helpers/constants
import * as G from '../helpers';
// utilities
import { sendRequest } from '../utilities/http';
//////////////////////////////////////////////////


const defaultOptions = {
  method: 'post',
  successMsg: null,
  showFailMsg: true,
  shouldCloseModal: true,
  shouldOpenLoader: true,
};

const useAsyncRequest = (props) => {
  const dispatch = useDispatch();

  const [asyncRequestState, setAsyncRequestState] = useState({ data: null, error: null, loading: true });

  const makeAsyncRequest = useCallback(async (endpoint, options) => {
    if (G.isNilOrEmpty(endpoint)) return;

    const mergedOptions = R.mergeRight(defaultOptions, options);

    const { method, successMsg, showFailMsg, successCallback, shouldCloseModal, shouldOpenLoader } = mergedOptions;

    if (G.isTrue(shouldOpenLoader)) dispatch(openLoader());

    try {
      const res = await sendRequest(method, endpoint, R.pick(['data', 'params'], mergedOptions));

      const { data, status } = res;

      if (G.isResponseSuccess(status, data, successMsg)) {
        if (G.isNotNil(data)) {
          setAsyncRequestState((prev) => ({ ...prev, data, loading: false }));

          if (G.isFunction(successCallback)) successCallback(res);
        }

        if (G.isTrue(shouldCloseModal)) dispatch(closeModal());
      } else {
        G.handleFailResponseSimple(
          res,
          showFailMsg,
          'withAsyncRequest -> withAsyncRequest',
        );
      }
    } catch (error) {
      G.handleException(error, 'withAsyncRequest');
    } finally {
      if (G.isTrue(shouldOpenLoader)) dispatch(closeLoader());
    }
  }, []);

  return { asyncRequestState, makeAsyncRequest };
};

export const withAsyncRequest = (Component) => (props) => {
  const request = useAsyncRequest(props);

  return <Component {...props} {...request} />;
};
